import axios from 'axios';
import { BaseURL,ProductionBaseURL } from '../../constants';

export const calculateOption = async (expiry, strike, put_call, ticker) => {
  try {
    const { data } = await axios.get('/api/get-expiredWatchlist-data', {
      params: {
        ticker: ticker,
        puttCall: put_call,
        strike: strike,
        expiration: expiry,
      },
      baseURL: ProductionBaseURL ? ProductionBaseURL : BaseURL,
    });
    let close = data[0].close;
    return close.toFixed(2);
  } catch (error) {
    return '-';
  }
};



// WEBPACK FOOTER //
// ./src/Pages/WatchList/functions.js